import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Container, Drawer as DrawerComponent, Grid, IconButton, Divider, Typography, Icon } from '@material-ui/core';
import { CloseIcon, BackBlackIcon } from '../Icons';

const Drawer = ({
  children,
  title,
  classes,
  open,
  isBackEnabled,
  onBack,
  onClose,
  fullWidth,
  paperStyles,
  closeIconFirst,
  withoutDivider,
  withoutClose,
  headerClass,
  titleVariant,
  titleClassName,
  inheritHeight,
  noScroll,
  ...props
}) => {
  const ref = React.useRef();

  React.useEffect(() => {
    if (ref.current && ref.current.children.length > 0) {
      ref.current.children[0].scrollTop = 0;
    }
  }, [children]);

  const fullContentClassName = title ? classes.fullContentWithHeader : classes.fullContent;
  const noScrollClassName = noScroll ? classes.noScroll : '';

  const heightDefinition = () => {
    if (fullWidth && inheritHeight) return classes.gridInheritHeight;
    if (fullWidth && !inheritHeight) return classes.gridContainer;
    return classes.container;
  };

  return (
    <DrawerComponent
      anchor="bottom"
      open={open}
      onClose={onClose}
      classes={{
        paperAnchorBottom: fullWidth ? classes.paperAnchorTop : classes.paperAnchorBottom,
        paper: paperStyles || null,
        root: classes.root || null,
      }}
      {...props}
      ref={ref}
    >
      <Container
        maxWidth="sm"
        data-testid="shared-parent-drawer"
        className={noScrollClassName}
        classes={{
          root: heightDefinition(),
        }}
      >
        {title && (
          <>
            <Grid container className={cx(classes.header, closeIconFirst && classes.reverse, headerClass)}>
              {isBackEnabled && (
                <Grid item>
                  <IconButton className={classes.backButton} onClick={onBack} edge="end" data-testid="drawer-back-btn">
                    <Icon component={BackBlackIcon} fontSize="small" />
                  </IconButton>
                </Grid>
              )}
              <Grid item className={classes.title}>
                <Typography variant={titleVariant} className={titleClassName}>
                  {title}
                </Typography>
              </Grid>
              {!withoutClose && (
                <Grid item>
                  <IconButton onClick={onClose} edge="start" data-testid="drawer-close-btn">
                    <CloseIcon />
                  </IconButton>
                </Grid>
              )}
            </Grid>
            {!withoutDivider && <Divider />}
          </>
        )}
        <Grid item xs={12} className={fullWidth ? fullContentClassName : classes.content}>
          {children}
        </Grid>
      </Container>
    </DrawerComponent>
  );
};

Drawer.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  children: PropTypes.node,
  /** If true drawer will be opened */
  open: PropTypes.bool,
  /** The title of the Drawer. */
  title: PropTypes.node,
  /** Close handler */
  onClose: PropTypes.func,
  /** If true container will take fullWidth */
  fullWidth: PropTypes.bool,
  /** If true the close icon will not be rendered */
  withoutClose: PropTypes.bool,
  /** The class forwarded to the header */
  headerClass: PropTypes.string,
  titleVariant: PropTypes.string,
  titleClassName: PropTypes.string,
  noScroll: PropTypes.bool,
};

Drawer.defaultProps = {
  classes: {},
  children: '',
  open: false,
  title: null,
  fullWidth: false,
  onClose: () => {},
  titleVariant: 'h3',
  noScroll: false,
};

export default Drawer;
